import React from 'react';
import { Helmet } from 'react-helmet';
import BookingSection from '../components/BookingSection';
import { Train, MapPin, Clock } from 'lucide-react';

const NavetteGareMidi = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Navette Gare du Midi Bruxelles | Transfert Thalys Eurostar</title>
        <meta name="description" content="Navette privée Gare du Midi Bruxelles. Transfert Thalys, Eurostar, TGV. Service porte-à-porte 24/7. Réservation instantanée." />
        <meta name="keywords" content="navette gare midi, taxi gare midi bruxelles, transfert thalys, eurostar bruxelles, navette gare" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/navette-gare-midi" />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-6xl font-bold text-center mb-6 bg-gradient-to-r from-gold via-yellow-300 to-gold bg-clip-text text-transparent">
            Navette Gare du Midi Bruxelles
          </h1>
          <p className="text-xl text-gray-300 text-center mb-8">
            Transfert privé Gare du Midi. Service porte-à-porte Thalys, Eurostar, TGV.
          </p>
        </div>
      </section>

      <section id="booking" className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <BookingSection defaultPickup="Gare du Midi, Bruxelles" />
        </div>
      </section>

      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gold mb-6">Transfert Privé Gare du Midi</h2>
          <p className="text-gray-300 mb-4">
            <strong>Navette privée Gare du Midi Bruxelles</strong> - Service VIP pour vos arrivées et départs en train 
            (Thalys, Eurostar, TGV, IC). Chauffeur vous attend avec panneau nominatif. Aide aux bagages incluse.
          </p>
          <h3 className="text-2xl font-bold text-gold mb-4 mt-8">Trajets Populaires</h3>
          <ul className="text-gray-300 space-y-2">
            <li>🚗 Gare du Midi → Centre Bruxelles (10 min)</li>
            <li>🚗 Gare du Midi → Aéroport Zaventem (25 min)</li>
            <li>🚗 Gare du Midi → Quartier Européen (15 min)</li>
            <li>🚗 Gare du Midi → Anvers (50 min)</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default NavetteGareMidi;